import { render } from "./AdminMedicines.vue?vue&type=template&id=51b3923b&scoped=true"
import script from "./AdminMedicines.vue?vue&type=script&lang=js"
export * from "./AdminMedicines.vue?vue&type=script&lang=js"

import "./AdminMedicines.vue?vue&type=style&index=0&id=51b3923b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b3923b"]])

export default __exports__